import { Component, Input, Output, EventEmitter, OnChanges, OnInit, AfterViewInit } from '@angular/core';
import { Direction } from '../../models/direction.enum';
import { LineItem } from '../../models/lineitem';
import { Subject } from '../../../../node_modules/rxjs';
import { AuthorityPointGroup } from '../../models/authoritypointgroup';
import { SelectItem } from 'primeng/api';


@Component({
  selector: 'change-request-line-item',
  templateUrl: './changerequest-line-item.component.html',
  styleUrls: ['./changerequest-line-item.component.scss']
})
export class ChangeRequestLineItemComponent implements OnChanges {

  @Input() lineItem: LineItem;
  @Output() undo: EventEmitter<LineItem> = new EventEmitter();
  @Input()
  resetDirection: Subject<any>;
  @Input() directionLock;
  @Input() authorityPointGroupListChild: AuthorityPointGroup[];
  @Input() line11Lock;
  Direction = Direction;
  directionListForModify: SelectItem[];
  private readonly directionsInOrder: Array<Direction> = [Direction.N, Direction.S, Direction.E, Direction.W, Direction.B];


  ngOnChanges() {

    if (this.authorityPointGroupListChild !== undefined) {
      this.loadDirections();
    }

    this.resetDirection.subscribe(event => {
      this.lineItem.newDirection = this.lineItem.direction;
    });
  }

  userClickedUndo(): void {
    this.undo.emit(this.lineItem);
  }

  loadDirections() {
    this.directionListForModify = new Array<SelectItem>();
    let directionList = new Array<SelectItem>();
    let fromPoint = false;
    let toPoint = false;
    this.authorityPointGroupListChild.forEach(authorityPointGroup => {
      authorityPointGroup.points.forEach(point => {
        if (point.displayName === this.lineItem.fromPoint.displayName &&
          point.location.track.name === this.lineItem.fromPoint.location.track.name) {
          fromPoint = true;
          point.location.subdivision.directions.forEach(direction => {
            directionList.push({ label: Direction[direction].toString(), value: direction.toString() })
          }
          );
        }
        if (point.displayName === this.lineItem.toPoint.displayName &&
          point.location.track.name === this.lineItem.toPoint.location.track.name
        ) {
          point.location.subdivision.directions.forEach(direction => {
            toPoint = true;
            directionList.push({ label: Direction[direction].toString(), value: direction.toString() })
          }
          );
        }
      })
    });
    if (!fromPoint || !fromPoint) {
      this.loadDirectionDropdown(this.directionsInOrder);
    } else {
      directionList.forEach(direction => {
        if (!this.checkDuplicateDirections(direction)) {
          this.directionListForModify.push(direction);
        }
      });
    }
  }

  checkDuplicateDirections(obj) {
    let res = false;
    this.directionListForModify.forEach(item => {
      if (obj.label === item.label) {
        res = true;
      }
    });
    return res;
  }

  loadDirectionDropdown(directions: Array<Direction>): void {
    this.directionListForModify.splice(0);
    this.directionsInOrder.forEach(directionInOrder => {
      if (directions.findIndex(direction => direction === directionInOrder) !== -1) {
        this.directionListForModify.push({ label: directionInOrder.toString(), value: Direction[directionInOrder].toString() })
      }
    });
  }
}
